import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { WritingHistoryService, type WritingExamRecord } from '../../../services/writing-history.service';

@Component({
  selector: 'app-writing-history',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './writing-history.component.html',
  styleUrl: './writing-history.component.scss',
  imports: [RouterLink]
})
export class WritingHistoryComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly writingHistory = inject(WritingHistoryService);

  protected readonly items = signal<WritingExamRecord[]>([]);
  protected readonly loading = signal(true);
  protected readonly error = signal<string | null>(null);
  protected readonly lastKey = signal<string | null>(null);

  ngOnInit(): void {
    this.loadMore();
  }

  protected loadMore(): void {
    this.loading.set(true);
    this.error.set(null);
    const key = this.lastKey();
    this.writingHistory
      .listHistory(20, key ?? undefined)
      .then((res) => {
        const validItems = res.items.filter((i) => i.combinationId && i.tasks);
        if (!key) {
          this.items.set(validItems);
        } else {
          this.items.update((prev) => [...prev, ...validItems]);
        }
        this.lastKey.set(res.lastKey);
      })
      .catch(() => this.error.set('加载失败，请稍后重试'))
      .finally(() => this.loading.set(false));
  }

  protected formatDate(iso: string): string {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
    catch {
      return iso;
    }
  }

  protected openResult(record: WritingExamRecord): void {
    const [year, month, combinationNumber] = record.combinationId.split('-').map(Number);
    this.router.navigate(
      ['/writing/results', year, month, combinationNumber],
      { state: { record, fromHistory: true } }
    );
  }
}
